import React, { FC, useEffect, useState } from 'react';
import { FormControl, FormHelperText, InputLabel, Select } from '@material-ui/core';
import Domain from '../../interfaces/api/Domain';
import { Skeleton } from '@material-ui/lab';
import api from '../../config/api';
import { getJsonResponse } from '../../utils/ApiUtils';
import { CollectionResponse } from '../../interfaces/api/api';
import useAuth from '../../hooks/api/useAuth';

interface BaseProps {
  useLegacyId?: boolean;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  className?: any;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  onChange: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
}

interface LegacyDomainProps extends BaseProps {
  useLegacyId: true;
  value?: number;
}

interface NewDomainProps extends BaseProps {
  useLegacyId?: false;
  value?: string;
}

type Props = LegacyDomainProps | NewDomainProps;

const DomainSelect: FC<Props> = React.forwardRef<any, Props>(
  ({ useLegacyId, onChange, className, value, helperText, required, ...props }, ref) => {
    const [domains, setDomains] = useState<Domain[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string>();
    const { fetch } = useAuth();

    useEffect(() => {
      let ignore = false;
      const { endpoint, ...options } = api.agency.getDomains();

      fetch(endpoint, options)
        .then((response) => getJsonResponse<CollectionResponse<Domain>>(response))
        .then((collection) => {
          if (ignore) return;

          setDomains(collection.items);
          setLoading(false);
        })
        .catch((e) => {
          if (ignore) return;

          setError(e.message);
          setLoading(false);
        });

      return () => {
        ignore = true;
      };
    }, []);

    if (loading) {
      return <Skeleton height={50} />;
    }

    if (error) {
      return <div style={{ color: '#f44336' }}>{error}</div>;
    }

    return (
      <FormControl
        ref={ref}
        className={className}
        variant='outlined'
        required={required}
        error={props.error}
        {...props}
      >
        <InputLabel>Domaine</InputLabel>
        <Select native value={value} onChange={onChange} label='Domaine *'>
          <option value='' />
          {domains.map((domain, key) => (
            <option key={key} value={useLegacyId ? domain.legacyId : domain.id}>
              {domain.name}
            </option>
          ))}
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  }
);

export default React.memo(DomainSelect);
